*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

.item-inner {
  user-select: none;

  display: flex;
  gap: 8px;
  align-items: center;

  height: 32px;
  padding: 0 8px;
  border-radius: calc(infinity * 1px);

  font-size: var(--wui-font-size, 14px);
  color: inherit;
  white-space: nowrap;

  outline: none;

  transition:
    color var(--wui-duration-feedback, 100ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1)),
    background-color var(--wui-duration-feedback, 100ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));
}

.item-inner:focus-visible {
  color: var(--wui-color-on-accent, #fff);
  background: var(--wui-color-accent, #08f);
}

:host([active]) .item-inner {
  color: inherit;
  background: var(--wui-color-border, rgb(0 0 0 / 0.1));
}

@media (hover: hover) and (pointer: fine) {
  :host(:hover) .item-inner {
    color: var(--wui-color-on-accent, #fff);
    background: var(--wui-color-accent, #08f);
  }
}

.item-label {
  overflow: hidden;
  flex: 1;

  min-width: 0;

  color: inherit;
  text-overflow: ellipsis;
}

.item-suffix {
  flex: none;
  opacity: 0.4;
}
